import * as $ from "jquery";

export function init() {
	$('.js-image-switcher-toggle').each(function(){
		var $this = $(this);
		var $switcherImage = $this.find('.image-switcher__image:first');
		$switcherImage.addClass('state-visible');

		$(this).on('click', function(){
			$switcherImage.toggleClass('state-visible');
		});
	});
}



// WEBPACK FOOTER //
// ./js/PFF/modules/imageSwitcher.ts